// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"jIjgn7qoTMH3b4e0jW3j","Link":"QqohSkg5NSBKEgLCAL46"};